import { api, call, type FinishResult } from "@/lib/api";
import { toExerciseView } from "./model";

export type { FinishResult };

export async function previewSwap(sessionId: string, workoutExerciseId: string, exerciseId: string, locale: string) {
  const res = await call(
    api.sessions[":id"]["swap-preview"].$get({ param: { id: sessionId }, query: { workoutExerciseId, exerciseId } }),
  );
  return { exercise: toExerciseView(res.exercise, locale), suggestion: res.suggestion, last: res.last };
}

export function discardSession(sessionId: string) {
  return call(api.sessions[":id"].$delete({ param: { id: sessionId } }));
}

export function finishSession({
  sessionId,
  ...json
}: {
  sessionId: string;
  feeling: number | null;
  notes: string | null;
  durationMin?: number;
}) {
  return call(api.sessions[":id"].finish.$post({ param: { id: sessionId }, json }));
}
